// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".JhcyY1rhHkKdfTBsvoQ4WA\\=\\= {\n  text-transform: uppercase;\n}\n", "",{"version":3,"sources":["webpack://./src/content/styles/LessonPlayerUsersPanel.module.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;AAC3B","sourcesContent":[".capitalize {\n  text-transform: uppercase;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"capitalize": "JhcyY1rhHkKdfTBsvoQ4WA=="
};
export default ___CSS_LOADER_EXPORT___;
